import React from 'react';
import { OutlinedButton, TextInput } from '../../../../../components';

const AddIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/AddIcon.svg`;

const DeliverablesSection = ({
    newDeliverable,
    setNewDeliverable,
    handleAddDeliverable,
    SelectedBrief,
    ExistingDeliverables,
    handleDeleteDeliverable
}) => {
    return (
        <div className='textAreacontainer' style={{ position: 'relative' }}>
            <p style={{ fontWeight: '700', fontSize: '14px', lineHeight: '24px' }}>Deliverables & Responsibilities</p>
            <div style={{ display: 'flex', marginBottom: '10px' }}>
                <TextInput 
                    style={{ width: '85%', marginRight: '10px' }} 
                    placeholder='Add new deliverable' 
                    value={newDeliverable} 
                    onChange={(e) => setNewDeliverable(e.target.value)} 
                />
                <img src={AddIcon} style={{ cursor: 'pointer' }} alt='add icon' id='addDeliverable' onClick={handleAddDeliverable} />
            </div>
            <div className='deliverablesArea'>
                <div className='deliverablesArea_'>
                    {SelectedBrief?.projectPlan[0]?.deliverables?.map((item, index) => (
                        <>
                            <div key={index} style={{ 
                                display: 'flex', 
                                justifyContent: 'space-between', 
                                marginBottom: '2%', 
                                alignItems: 'center', 
                                padding: '2.5%', 
                                background: '#fff', 
                                borderRadius: '10px' 
                            }}>
                                <div style={{ flex: 1, color: '#AFAFAF' }}>{item.nameOfItem}</div>
                                {!ExistingDeliverables.includes(item.nameOfItem) && (
                                    <OutlinedButton 
                                        style={{ minWidth: '10px', padding: '0px 5px', marginLeft: '5px', fontSize: '8px', color: '#ff4444' }}
                                        onClick={() => handleDeleteDeliverable(index)}
                                    >
                                        X
                                    </OutlinedButton>
                                )}
                            </div>
                        </>
                    )) || ''}
                </div>
            </div>
        </div>
    );
};

export default DeliverablesSection;